/**
 * --------------------------------------------------
 * components/MoibleMenu.ts
 * Mobile Menu
 * --------------------------------------------------
*/

import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from "@/theme/Cart";
import { debounce } from 'lodash';

@Component
export class MobileMenu extends ThemeComponent {
    @Ref({required: false}) stateTrigger!: HTMLElement[];
    @Ref({required: false}) stateNav!: HTMLElement[];
    @Ref({required: false}) highlights!: HTMLElement[];
    @Ref({required: false}) grandchildToggle!: HTMLButtonElement[];
    @Ref({required: false}) cartCount!: HTMLElement;

    private _onOpenChange = new SimpleEvent<string>();
    public get onOpenChange() {
        return this._onOpenChange.asEvent();
    }

    init() {
        this.setEventListeners();
    }

    /**
     * Set event listeners.
     */
    setEventListeners() {
        if (this.stateTrigger.length > 0) {
            for(const trigger of this.stateTrigger) {
                this.$listen(trigger, 'click', () => {
                    this.handleStateChange(trigger, trigger.dataset.child);
                });
            }
        }

        if (this.grandchildToggle.length > 0) {
            for(const toggle of this.grandchildToggle) {
                this.$listen(toggle, 'click', () => {
                    toggle.classList.toggle('is-active');
                    toggle.nextElementSibling?.classList.toggle('is-active');
                });
            }
        }

        this.$subscribe(cart.onChange, debounce(() => {
            this.updateCartCount();
        }, 300));
    }

    /**
     * Handle multistate menu change.
     * @param child - trigger child menu handle
     */
    handleStateChange(parent: HTMLElement, child: string|undefined) {
        if (this.stateTrigger.length === 0) { return; }

        for(const nav of this.stateNav) {
            nav.classList.remove('is-active');
            if (nav.dataset.parent === child) {
                nav.classList.add('is-active');
            }
        }

        for(const trigger of this.stateTrigger) {
            trigger.classList.remove('is-active');
            if (trigger === parent) {
                trigger.classList.add('is-active');
            }
        }
    }

    /**
     * Handle mega menu.
     */
    handleMagaMenu() {
        for(const highlights of this.highlights) {
            highlights?.classList.add('is-active');
        }
    }

    /**
     * Update cart count
     * @returns
     */
    updateCartCount() {
        if (!this.cartCount) { return; }
        const itemCount = cart.items.filter((item) => ~~item.quantity > 0)
            .map((obj) => ~~obj.quantity)
            .reduce((a, b) => a + b, 0);

        this.cartCount.innerHTML = ` (${itemCount})`;
    }
}
